module.exports = __webpack_public_path__ + "static/media/items_imgs.d6aa6995.png";